import "reflect-metadata";
export class MeObject {
}
